<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M909.8 346.7c-22.2-52.4-53.8-99.4-94.3-139.9-40.4-40.4-87.4-72.1-139.9-94.3C621.2 89.6 563.7 78 504.2 78s-117 11.6-171.3 34.5c-52.4 22.2-99.4 53.8-139.9 94.3-40.4 40.4-72.1 87.4-94.3 139.9C75.8 401 64.2 458.6 64.2 518s11.6 117 34.5 171.3c22.2 52.4 53.8 99.4 94.3 139.9 40.4 40.4 87.4 72.1 139.9 94.3 54.3 22.9 111.9 34.5 171.3 34.5s117-11.6 171.3-34.5c52.4-22.2 99.4-53.8 139.9-94.3 40.4-40.4 72.1-87.4 94.3-139.9 22.9-54.3 34.5-111.9 34.5-171.3s-11.5-117-34.4-171.3zM505.5 901.5C294.3 901.5 123 730.2 123 519c0-211.3 171.3-382.5 382.5-382.5C716.8 136.5 888 307.7 888 519c0 211.2-171.2 382.5-382.5 382.5z" :fill="_fill" />
      <path data-follow-fill="currentColor" d="M715.8 547h-423c-16 0-29-13-29-29s13-29 29-29h423c16 0 29 13 29 29s-13 29-29 29z" :fill="_fill" />
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
